import { render, staticRenderFns } from "./HangMan.vue?vue&type=template&id=1fb142f2&scoped=true&"
import script from "./HangMan.vue?vue&type=script&lang=js&"
export * from "./HangMan.vue?vue&type=script&lang=js&"
import style0 from "./HangMan.vue?vue&type=style&index=0&id=1fb142f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb142f2",
  null
  
)

export default component.exports